import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import clinicApi from '../api/clinic/clinicApi';
import cmsApi from '../api/cms/cmsApi';

const ClinicContext = createContext({ clinic: null, landing: null, loading: true });

// Applies the tenant's brand colour to the design tokens (SaaS theming).
const isHex = (v) => /^#[0-9a-f]{6}$/i.test(v || '');

const applyBrand = ({ primaryColor, secondaryColor, logoUrl }) => {
  const root = document.documentElement;
  if (isHex(primaryColor)) {
    root.style.setProperty('--color-primary', primaryColor);
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', primaryColor);
  }
  if (isHex(secondaryColor)) root.style.setProperty('--color-secondary', secondaryColor);
  if (logoUrl) {
    const icon = document.querySelector('link[rel="icon"]');
    if (icon) {
      icon.setAttribute('href', logoUrl);
      icon.removeAttribute('type');
    }
  }
};

export function ClinicProvider({ children }) {
  const [state, setState] = useState({ clinic: null, landing: null, loading: true });

  useEffect(() => {
    let alive = true;
    Promise.all([clinicApi.getClinic(), cmsApi.getLanding()])
      .then(([clinic, landing]) => {
        if (!alive) return;
        applyBrand(clinic);
        document.title = `${clinic.name} · Patient Portal`;
        setState({ clinic, landing, loading: false });
      })
      .catch(() => alive && setState((s) => ({ ...s, loading: false })));
    return () => {
      alive = false;
    };
  }, []);

  const value = useMemo(() => state, [state]);
  return <ClinicContext.Provider value={value}>{children}</ClinicContext.Provider>;
}

export const useClinic = () => useContext(ClinicContext);
